// React
import React from 'react';
// External
import { withRouter } from 'react-router-dom';
import {
    Col, Container, Form, Row
} from 'react-bootstrap';
import { Layer, Stage } from 'react-konva';
import { connect } from 'react-redux';
// Style
import './styles.scss';
// Images
// Internal
import ICON_OPTIONS from 'constants/iconOptions';
import POSITIONS_OPTIONS from 'constants/positionsOptions';
import URLImage from 'components/shared/atoms/URLImage/URLImage';
import EngravingSelector from 'components/shared/atoms/EngravingSelector/EngravingSelector';
import resizedImage from 'components/shared/molecules/ResizedImage/ResizedImage';
import { updateEngraving } from 'stores/actions';

class EngravingOptions extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            errors: [],
            iconLeftPos: 500 / 25,
            iconRightPos: 500 - 96 - (500 / 25),
            position: 500 / 25,
            placement: 'Left',
            icon: 'None',
            midPos: 500 / 2 - 96 / 2,
            selectedPlaqueSize: null,
            aspectW: 4,
            aspectH: 4,
            adjustedWidth: 500,
            adjustedHeight: 500,
            iconRatio: 1,
            customiseTextImage: null,
            customiseTextX: 0,
            customiseTextY: 0,
            customiseTextImageHeight: 0,
            canvasContainerWidth: null,
            responsiveScale: 1,
            iconSize: 96,
            dividerConstant: 25 // 25 = a variable which proven to make it looks nice
        };

        this.handleSubmit = this.handleSubmit.bind(this);
        this.calculateCanvasSize = this.calculateCanvasSize.bind(this);
    }

    componentDidMount() {
        const modalTitle = document.getElementsByClassName('modal-title')[0];
        if (typeof modalTitle !== 'undefined') {
            modalTitle.scrollIntoView();
        }
        const navbarBrand = document.getElementsByClassName('navbar-brand')[0];
        if (typeof navbarBrand !== 'undefined') {
            navbarBrand.scrollIntoView();
        }

        const canvasContainer = document.querySelector('.engraving-options-image-container');

        let containerWidth = canvasContainer.offsetWidth;

        if (containerWidth > 500) {
            containerWidth = 500;
        }

        this.setState({
            canvasContainerWidth: containerWidth,
            responsiveScale: containerWidth / 500,
            dividerConstant: 25 * (containerWidth / 500),
            iconSize: 96 * (containerWidth / 500)
        }, () => {
            this.initialiseStates();
        });
    }

    async handleSubmit() {
        const errors = [];

        if (this.state.icon === '') {
            errors.push('icon');
        }
        if (this.state.placement === null) {
            errors.push('placement');
        }

        await this.setError(errors);
        const container = document.querySelector('.konvajs-content canvas');
        const img = container.toDataURL();
        const engraving = {
            ...this.props.engraving,
            engravingOptionsImage: img,
            icon: this.state.icon,
            iconPlacement: this.state.placement
        };

        return errors.length > 0 ? null : engraving;
    }

    setError(error) {
        this.setState({ errors: error });
    }

    // eslint-disable-next-line class-methods-use-this
    setIconXPositionAndTextXYPosition(
        isLeft,
        iconXPosition,
        iconSpacing,
        halfIconWidth,
        containerHeight,
        textHeight
    ) {
        let adjustedIconSpacing = iconSpacing;
        let adjustedHalfIconWidth = halfIconWidth;
        let adjustedIconXPosition = iconXPosition;
        if (this.state.icon === 'None') {
            adjustedIconSpacing = 0;
            adjustedHalfIconWidth = 0;
            adjustedIconXPosition = 0;
        }

        let customiseTextX = 0;
        const iconSrc = this.getIcon(this.state.icon);
        if (iconSrc && isLeft) {
            customiseTextX = (adjustedIconSpacing + adjustedHalfIconWidth);
        } else if (iconSrc) {
            customiseTextX = -(adjustedIconSpacing + adjustedHalfIconWidth);
        }
        this.setState({
            position: adjustedIconXPosition,
            // default: icon is on the left so text (customised text) is on the right
            customiseTextX,
            customiseTextY: containerHeight / 2 - textHeight / 2
        });
    }

    getIcon = (icon) => {
        const anIcon = ICON_OPTIONS.find((x) => x.name === icon);
        if (typeof anIcon === 'undefined') {
            return null;
        }
        return anIcon.path;
    };

    initialiseStates() {
        const selectedVessel = this.props.engraving.productId;
        fetch('../fpc_config.json')
            .then((r) => r.json())
            .then((data) => {
                const savedCustomiseText = this.props.engraving.customTextImage;
                const selectedConfig = data.Config_File.find((x) => x.SugarID === selectedVessel);
                if (!selectedConfig) {
                    return;
                }
                this.setState({
                    selectedPlaqueSize: selectedConfig.Dimensions,
                    customiseTextImage: savedCustomiseText
                }, () => {
                    if (this.state.selectedPlaqueSize === '0') {
                        alert('Sorry, the selected plaque size doesn\'t support image options');
                    } else {
                        let selectedPlaqueWidth;
                        let selectedPlaqueHeight;

                        if (selectedConfig.Dimensions.indexOf('x') > -1) {
                            const ratioArr = selectedConfig.Dimensions.split('x');
                            selectedPlaqueWidth = ratioArr[0];
                            selectedPlaqueHeight = ratioArr[1];
                        } else {
                            const ratio = selectedConfig.Dimensions;
                            selectedPlaqueWidth = ratio;
                            selectedPlaqueHeight = ratio;
                        }

                        const stateList = {
                            aspectW: selectedPlaqueWidth,
                            aspectH: selectedPlaqueHeight,
                            iconRatio: parseFloat(selectedConfig.Icon_Ratio)
                        };

                        if (this.props.engraving.icon) {
                            stateList.icon = this.props.engraving.icon;
                        }

                        if (this.props.engraving.iconPlacement) {
                            stateList.placement = this.props.engraving.iconPlacement;
                        }

                        this.setState(stateList, () => {
                            this.calculateCanvasSize();
                        });
                    }
                });
            });
    }

    hasError(fieldError) {
        return this.state.errors.indexOf(fieldError) >= 0;
    }

    calculateCanvasSize() {
        const containerWidth = this.state.canvasContainerWidth;

        const containerHeight = (this.state.aspectH / this.state.aspectW) * containerWidth;
        const textImage = new window.Image();

        textImage.onload = async () => {
            const iconSpacing = containerWidth / this.state.dividerConstant;
            const halfIconWidth = (this.state.iconSize * this.state.iconRatio) / 2;

            // normalise textImage width & height;
            let textImageWidth = textImage.width;
            let textImageHeight = textImage.height;

            if (textImageWidth > 500) {
                textImageWidth = 500;
                textImageHeight = (textImage.height / textImage.width) * textImageWidth;
            }

            textImageWidth *= this.state.responsiveScale;
            textImageHeight *= this.state.responsiveScale;

            const resizedImageResult = await resizedImage(
                this.state.customiseTextImage,
                textImageWidth,
                textImageHeight
            );

            this.setState((prevState) => {
                return {
                    customiseTextImage: resizedImageResult,
                    customiseTextImageHeight: textImageHeight,
                    adjustedWidth: containerWidth,
                    adjustedHeight: containerHeight,
                    midPos: containerHeight / 2
                        - (prevState.iconSize * prevState.iconRatio) / 2,
                    iconLeftPos: containerWidth / prevState.dividerConstant,
                    iconRightPos: containerWidth
                        - (prevState.iconSize * prevState.iconRatio)
                        - (containerWidth / prevState.dividerConstant)
                };
            });

            this.setIconXPositionAndTextXYPosition(
                this.state.placement === 'Left',
                this.state.placement === 'Left'
                    ? (containerWidth / this.state.dividerConstant)
                    : (containerWidth
                        - (this.state.iconSize * this.state.iconRatio)
                        - (containerWidth / this.state.dividerConstant)
                    ),
                iconSpacing,
                halfIconWidth,
                containerHeight,
                textImageHeight
            );
        };

        textImage.src = this.state.customiseTextImage;
    }

    render() {
        return (
            <Container fluid className="engraving-container engraving-options-container">
                <Row>
                    <Col lg={7} className="col-12">
                        <div className="section-description mb">
                            <h5>Engraving Options</h5>
                        </div>

                        <div className="engraving-options-wrapper">
                            <Form className="engraving-options-form">
                                <Form.Row>
                                    <Form.Group as={Col}>
                                        <Form.Label>Icon</Form.Label>
                                        <EngravingSelector
                                            options={ICON_OPTIONS}
                                            placeholder="Select Icon"
                                            name="iconOptions"
                                            controlClassName={this.hasError('icon') ? 'is-invalid' : ''}
                                            hasError={this.hasError('icon')}
                                            value={this.state.icon}
                                            onChange={(value) => {
                                                this.setError([]);
                                                this.setState({ icon: value }, () => {
                                                    this.setIconXPositionAndTextXYPosition(
                                                        this.state.placement === 'Left',
                                                        this.state.placement === 'Left'
                                                            ? this.state.iconLeftPos
                                                            : this.state.iconRightPos,
                                                        this.state.adjustedWidth / this.state.dividerConstant,
                                                        (this.state.iconSize * this.state.iconRatio) / 2,
                                                        this.state.adjustedHeight,
                                                        this.state.customiseTextImageHeight,
                                                    );
                                                });
                                            }}
                                        />
                                    </Form.Group>

                                    <Form.Group as={Col}>
                                        <Form.Label>Icon Position</Form.Label>
                                        <EngravingSelector
                                            options={POSITIONS_OPTIONS}
                                            placeholder="Select Position"
                                            name="positionsOptions"
                                            controlClassName={
                                                this.hasError('placement') ? 'is-invalid' : ''
                                            }
                                            hasError={this.hasError('placement')}
                                            value={this.state.placement}
                                            onChange={(value) => {
                                                this.setState({
                                                    placement: value
                                                });

                                                this.setIconXPositionAndTextXYPosition(
                                                    value === 'Left',
                                                    value === 'Left'
                                                        ? this.state.iconLeftPos
                                                        : this.state.iconRightPos,
                                                    this.state.adjustedWidth / this.state.dividerConstant,
                                                    (this.state.iconSize * this.state.iconRatio) / 2,
                                                    this.state.adjustedHeight,
                                                    this.state.customiseTextImageHeight,
                                                );
                                            }}
                                        />
                                    </Form.Group>
                                </Form.Row>
                            </Form>
                        </div>
                    </Col>
                    <Col lg={5} className="col-12">
                        <div className="engraving-options-image-container">
                            <Stage
                                width={this.state.adjustedWidth}
                                height={this.state.adjustedHeight}
                                id="container"
                            >
                                <Layer>
                                    <URLImage
                                        src={this.state.customiseTextImage}
                                        x={this.state.customiseTextX}
                                        y={this.state.customiseTextY}
                                    />
                                    {
                                        this.getIcon(this.state.icon)
                                            ? (
                                                <URLImage
                                                    src={this.getIcon(this.state.icon)}
                                                    x={this.state.position}
                                                    y={this.state.midPos}
                                                    width={this.state.iconSize * this.state.iconRatio}
                                                    height={this.state.iconSize * this.state.iconRatio}
                                                />
                                            ) : null
                                    }
                                </Layer>
                            </Stage>
                        </div>
                    </Col>
                </Row>
            </Container>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        engraving: state.engraving
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        updateEngraving: (engravingObj) => dispatch(updateEngraving(engravingObj))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(EngravingOptions));
